import { AxiosRequestConfig, AxiosResponse} from 'axios';
import axios from '../utils/axiosExt';
import Auth from '../utils/auth';
import { prepareApiRequestData, validateGetApiInputs } from '../utils/apiInputValidation';

interface ApiResponse<T> {
    data: T;
    status: number;
    message: string;
}

const handleError = (error:any):Promise<any> => {
    return Promise.reject(error);
}

export const getData = async <T>(
    endpoint:string,
    params?: Record<string, any>,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        validateGetApiInputs(endpoint);
        const response:AxiosResponse<ApiResponse <T>> = await axios.get(endpoint,{
            ...config,
            params,
            headers: { ...Auth.loggedIn().headers }
        });
        return response?.data;
    }catch (error){
        return handleError(error)
    }
}

export const getDataWithCache = async <T>(
    endpoint:string,
    params?: Record<string, any>,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        validateGetApiInputs(endpoint);
        const response:AxiosResponse<ApiResponse <T>> = await axios.getWithCache(endpoint,{
            ...config,
            params,
            headers: { ...Auth.loggedIn().headers }
        });
        return response?.data;
    }catch (error){
        return handleError(error)
    }
}

export const postDataWithCache = async <T>(
    endpoint:string,
    data: any,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        const response:AxiosResponse<ApiResponse <T>> = await axios.postWithCache(endpoint, prepareApiRequestData('post', endpoint, data),
            { ...config, headers: { ...Auth.loggedInWithJSON().headers }
        });
        return response?.data;
    }catch (error){
        return handleError(error)
    }
}

export const getDataParams = async <T>(
    endpoint:string,
    queryParams?: Record<string, any>,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        validateGetApiInputs(endpoint);
        const response:AxiosResponse<ApiResponse <T>> = await axios.get(endpoint,{
            ...config,
            params:queryParams,
            headers: { ...Auth.loggedIn().headers}
           });
        return response?.data
    }catch (error){
        return handleError(error)
    }
}

export const postDataJSON = async <T>(
    endpoint:string,
    data: any,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        const response:AxiosResponse<ApiResponse <T>> = await axios.post(endpoint, prepareApiRequestData('post', endpoint, data),
            { ...config, headers: { ...Auth.loggedInWithJSON().headers }
        });
        return response?.data
    }catch (error){
        return handleError(error)
    }
}

export const putDataJSON = async <T>(
    endpoint:string,
    data: any,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        const response:AxiosResponse<ApiResponse <T>> = await axios.put(endpoint, prepareApiRequestData('put', endpoint, data),
            { ...config, headers: { ...Auth.loggedInWithJSON().headers }
        });
        return response?.data
    }catch (error){
        return handleError(error)
    }
}

export const patchDataJSON = async <T>(
    endpoint:string,
    data: any,
    config?:AxiosRequestConfig
):Promise<ApiResponse <T>>=> {
    try{
        const response:AxiosResponse<ApiResponse <T>> = await axios.patch(endpoint, data,
            { ...config, headers: { ...Auth.loggedInWithJSON().headers }
        });
        return response?.data
    }catch (error){
        return handleError(error)
    }
}

export const postDataWithResponse = async <T>(
    endpoint:string,
    data: any,
    config?:AxiosRequestConfig
):Promise<AxiosResponse<ApiResponse<T>>>=> {
    try{
        const response:AxiosResponse<ApiResponse <T>> = await axios.post(endpoint, prepareApiRequestData('post', endpoint, data),
            { ...config, headers: { ...Auth.loggedInWithJSON().headers }
        });
        return response
    }catch (error){
        return handleError(error)
    }
}